@keyframes fadeIn {
    0% { opacity: 0; }
    75% {opacity: 0;}
    100% { opacity: 1; }
}

.react-tags {
    position:relative;
    background:var(--thriveWhite);
    font-size: 12px;
    line-height:14px;
    cursor: text;
    width: 100%;
    padding: 2px 5px;

    &:focus {
        outline: none;
        outline-offset: unset;
    }
  }
  .react-tags.is-invalid {
    border-color:var(--thriveRed);
    box-shadow:0 0 0 2px #fd565340
  }
  .react-tags__label {
    left:-10000px;
    top:auto;
    width:1px;
    height:1px;
    overflow:hidden
  }
  .react-tags__list {
    display:inline;
    padding:0
  }
  .react-tags__list-item {
    display:inline;
    list-style:none
  }
  .react-tags__tag {
    margin:0 .25rem .25rem 0;
    padding: 4px 5px;
    border:0;
    border-radius:3px;
    background: var(--thriveCMSButtonColor);
    color: var(--thriveWhite);
    font-size:inherit;
    line-height:inherit
  }
  .react-tags__tag:hover {
    color:var(--thriveWhite);
    filter: brightness(95%);
  }
  .react-tags__tag:after {
    content:"";
    display:inline-block;
    width:.65rem;
    height:.65rem;
    clip-path:polygon(10% 0,0 10%,40% 50%,0 90%,10% 100%,50% 60%,90% 100%,100% 90%,60% 50%,100% 10%,90% 0,50% 40%);
    margin-left:.5rem;
    font-size:.875rem;
    background-color:var(--thriveWhite);
  }
  .react-tags__tag:hover:after {
    background-color:var(--thriveWhite);
  }
  .react-tags__combobox {
    display:inline-block;
    padding:.375rem .25rem;
    margin-bottom:.25rem;
    max-width:100%
  }
  .react-tags__combobox-input {
    max-width:100%;
    margin:0;
    padding:0;
    border:0;
    outline:none;
    background:none;
    font-size:inherit;
    line-height:inherit
  }
  .react-tags__combobox-input::placeholder {
    color:var(--thriveGreyDark);
    opacity:1
  }
  .react-tags__listbox {
    transition: top 0.1s;
    animation: fadeIn 0.2s;
    width: 400px;
    position:fixed;
    z-index:999;
    max-height:12.5rem;
    overflow-y:auto;
    background:var(--thriveWhite);
    border:1px solid var(--thriveChalk);
    border-radius:6px;
    box-shadow:#0000001a 0 10px 15px -4px,#0000000d 0 4px 6px -2px;
    right: calc(50% - 300px);

  }
  .react-tags__listbox-option {
    padding:.375rem .5rem
  }
  .react-tags__listbox-option:hover {
    cursor:pointer;
    background:var(--thriveGreyLight);
  }
  .react-tags__listbox-option:not([aria-disabled=true]).is-active {
    background:var(--thriveCMSTextEmphasisColor);
    color:var(--thriveWhite);
  }
  .react-tags__listbox-option[aria-disabled=true] {
    color:var(--thriveGreyDark);
    cursor:not-allowed;
    pointer-events:none;
  }
  .react-tags__listbox-option[aria-selected=true]:after {
    content:"✓";
    color: var(--thriveCheckbox);
    margin-left:.5rem
  }
  .react-tags__listbox-option[aria-selected=true]:not(.is-active):after {
    color:var(--thriveCMSTextEmphasisColor);
  }
  .tag-group {
    display:flex;
    flex-direction:column;
    flex-wrap:wrap;
    align-content:flex-start;
    padding:8px;
    gap:8px;
    background-color:#00000003;
    margin:.25rem .5rem .5rem .25rem;
    justify-content:flex-start;
    border:1px solid var(--thriveChalk);
    align-items:flex-start;
    border-radius:4px
  }
  .tag-group ul {
    margin:0
  }
  .tag-group>p {
    margin:0;
    font-size:.8125rem;
    line-height:1.5rem;
    color:var(--thriveCharcoal);
  }